import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { EventListItem } from '@app/models';
import { AppService } from '@app/services';
import { AppInfoService } from '@app/services/app-info.service';
import { SortService } from '@app/services/sort.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'qb-app-event-list',
  templateUrl: './app-event-list.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  styleUrls: ['./app-event-list.component.scss'],
  imports: [
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatNoDataRow,
    MatPaginator,
    DatePipe,
  ],
})
export class AppEventListComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @ViewChildren(MatSort) dataSorts: QueryList<MatSort>;
  @ViewChild('eventPaginator', { static: true }) eventPaginator: MatPaginator;

  @Input() showComment: boolean = false;
  @Input() showActionBy: boolean = false;
  @Input() approvedTerm: string = 'Rated';

  public loading: boolean = true;
  public eventDataSource: MatTableDataSource<EventListItem>;
  expandedElement: EventListItem | null;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 15];

  eventsColumnsToDisplay: string[] = ['eventDate', 'actionBy', 'name', 'comment'];

  constructor(
    private appServices: AppService,
    private app: AppInfoService,
    private sortService: SortService
  ) {}

  ngOnInit(): void {
    this.getAppEvents();

    this.app.triggerRefreshEventLog.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.getAppEvents();
    });
  }

  getAppEvents() {
    this.appServices
      .getAppEvents(this.app.id)
      .pipe(take(1))
      .subscribe(res => {
        let events = res.eventList;
        // Filtering & Showing Colbi Internal Notes only for QBAT Users
        if (!this.app.userIsQbat) {
          events = events?.filter(e => e.name !== 'QBAT Note');
        }
        this.eventDataSource = new MatTableDataSource(events);
        this.eventDataSource.paginator = this.eventPaginator;
        this.eventPaginator.pageIndex = 0;
        this.loading = false;
      });
  }

  setSorts() {
    this.eventDataSource = this.sortService.setDefaultSort(this.eventDataSource, this.dataSorts.get(0));
  }
}
